import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEqual = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 6H13M3 10H13",
		stroke: "currentColor",
		strokeLinecap: "round"
	})
});
export default SvgEqual;
